import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class SecretService {
  //constructor() { }

  encryptApiData(plainText: any) {
    if (plainText == null || plainText.length <= 0) {
      return null;
    }
    var random_number = Math.floor(Math.random() * Math.floor(9));
    plainText = plainText + '_' + random_number;
    return CryptoJS.AES.encrypt(plainText.trim(), environment.backendSecretKey).toString();
  }

  decryptApiData(ciphertext: any) {
    if (ciphertext == null || ciphertext.length <= 0) {
      return null;
    }
    var bytes = CryptoJS.AES.decrypt(ciphertext.trim(), environment.backendSecretKey);
    var plainTest = bytes.toString(CryptoJS.enc.Utf8);
    return plainTest.substring(0, plainTest.length - 2); // remove last 2 charaters
  }

  encryptLocalStorageData(plainText: any) {
    if (plainText == null || plainText.length <= 0) {
      return null;
    }
    var random_number = Math.floor(Math.random() * Math.floor(9));
    plainText = plainText + '+-*' + random_number + '***';
    return CryptoJS.AES.encrypt(plainText.trim(), environment.localStorageSecretKey).toString();
  }

  decryptLocalStorageData(ciphertext: any) {
    if (ciphertext == null || ciphertext.length <= 0) {
      return null;
    }
    var bytes = CryptoJS.AES.decrypt(ciphertext.trim(), environment.localStorageSecretKey);
    var plainTest = bytes.toString(CryptoJS.enc.Utf8);
    return plainTest.substring(0, plainTest.length - 7); // remove last 7 charaters
  }
}
